<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-md-12">
            <div class="header-title">Ordens novas</div>
            <p class="header-subtitle">Escolha entre criar uma invoice ou anexar invoice já existente.</p>
          </div>
          <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="row d-flex justify-content-center gap-3"> 
            <div class="col-md col-sm col-xl-6 col-xs-12 col-mobile">
              <div [ngClass]="generateInvoice ? 'card-selected' : ''" (click)="selectGenerateInvoice()" class="card-orders">
                <div style="display: flex; justify-content: center">
                  <img src="assets/image/invoice-icon.svg" alt="" />
                </div>
  
                <p class="title-card">Gerar invoice</p>
  
                <p class="description-card">
                  Gere sua invoice gratuitamente com a Xavi Pay.
                </p>
              </div> 
            </div>

            <div class="col-md col-sm col-xl-6 col-xs-12 col-mobile">
              <div [ngClass]="addExistingInvoice ? 'card-selected' : ''" (click)="selectAddExistingInvoice()" class="card-orders">
                <div style="display: flex; justify-content: center">
                  <img src="assets/image/files-icon.svg" alt="" />
                </div>
  
                <p class="title-card">Adicionar invoice existente</p>
  
                <p class="description-card">
                  Adicione invoice nos formatos .pdf .doc .png e .jpg.
                </p>
              </div>
            </div>
          </div>
       

          <div class="btn-content">
            <button [ngClass]="{'btn-gray-disabled': !generateInvoice && !addExistingInvoice, 'btn-blue-30': generateInvoice || addExistingInvoice}"
              [disabled]="!generateInvoice && !addExistingInvoice" (click)="goToInvoiceModal()" type="button"
              class="btn-xp-m2 btn-blue-30">
              Selecionar
            </button>
          </div>
        </div>

      </div>
    
    </div>
    
  </div>
</div>